/* Adult-humor filter (owner request, 2026-10-23). See snippets/sk-adult-attr.liquid.
 *
 * <html> classes (set in layout/theme.liquid before paint):
 *   sk-adult-ctx  this page is adult (adult product page / adult collection)
 *   sk-adult-on   the shopper switched "Show adult humor" on (localStorage sk_adult=1)
 * Plain list items are hidden by CSS alone. Carousel slides are different: the
 * slideshow only skips slides that carry the `hidden` ATTRIBUTE, so Liquid renders
 * adult slides with `hidden` and sync() lifts it when adult items may show.
 *
 * No MutationObserver on purpose (see the 2026-09-23 live-store freeze): content
 * that arrives later calls window.skAdult.sync(root) itself (product-recommendations.js).
 */
(function () {
  var html = document.documentElement;
  var KEY = 'sk_adult';

  function show() {
    return html.classList.contains('sk-adult-on') || html.classList.contains('sk-adult-ctx');
  }

  function sync(root) {
    var on = show();
    (root || document).querySelectorAll('slideshow-slide[data-sk-adult]').forEach(function (slide) {
      if (slide.hidden === !on) return;
      slide.hidden = !on;
    });
    document.querySelectorAll('[data-sk-adult-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-checked', html.classList.contains('sk-adult-on') ? 'true' : 'false');
    });
  }

  function set(on) {
    try { on ? localStorage.setItem(KEY, '1') : localStorage.removeItem(KEY); } catch (e) {}
    html.classList.toggle('sk-adult-on', on);
    sync(document);
    document.dispatchEvent(new CustomEvent('sk:adult-change', { detail: { on: on } }));
  }

  // Delegated, so toggles re-rendered by the filter bar keep working.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sk-adult-toggle]');
    if (!btn) return;
    e.preventDefault();
    set(!html.classList.contains('sk-adult-on'));
  });

  window.skAdult = { show: show, sync: sync, set: set };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(document); });
  else sync(document);
})();
